export default __webpack_public_path__ + "media/images/celeste_local-4a278b559a7d72512625cb70f6a467a6.png";